import { TApplicationState } from 'shared/types/redux';
import { TUserState } from 'shared/types/user';

export const selectUser = (state: TApplicationState): TUserState => {
  return state.userState;
};
